export default {
    'ClickUp':  {
        'api': window.X_ClickUpApi || process.env.REACT_APP_CLICKUPAPI,
        'access_token': window.X_ClickUpAccessToken || process.env.REACT_APP_CLICKUPACCESSTOKEN,
        'team_id': window.X_ClickUpTeamId || process.env.REACT_APP_CLICKUPTEAMID,
    },
    'idMapper': {
        'api': window.X_idMapperApi || process.env.REACT_APP_IDMAPPERID,
    },
    'tasks': {
        'refreshInterval': window.X_RefreshCurrentStatus || process.env.REACT_APP_REFRESHCURRENTSTATUS
    },
    'teams': {
        'dev': window.X_ClickUpDevTeam || process.env.REACT_APP_CLICKUPDEVTEAMS
    }

};
